/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Form_CapabilitiesInputs */



/**
* | output |
* | --- |
* | "Capabilities" |
*
* @param {Private_Models_Form_CapabilitiesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_form_capabilities = /** @type {((inputs?: Private_Models_Form_CapabilitiesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Form_CapabilitiesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fähigkeiten")
	return /** @type {LocalizedString} */ ("Capabilities")
});